'use strict';

export const DIRECTION_VERTICAL = "vertical";

export const DIRECTION_HORIZONTAL = "horizontal";

export const MOBILE_SWIPE_EVENTS = ['touchstart', 'touchend'];

export const PC_SWIPE_EVENTS = ['mousedown', 'mouseup'];

export const MOBILE_SWIPE_THUMBNAIL_EVENTS = ['touchstart', 'touchmove', 'touchend'];

export const PC_SWIPE_THUMBNAIL_EVENTS = ['mousedown', 'mousemove', 'mouseup'];

export const STATE_PAUSED = "paused";

export const STATE_PLAYING = "playing";

export const AUTOPLAY_INTERVAL = 5000;

export const INITAL_CURRENT_SLIDE = 0;

export const MIN_SWIPE_PORCENTAGE = 30;
